const getInitialPurchasePage = (pathname, code) => {
  if (pathname.includes('practice-session')) {
    return code
      ? `/pga-coaching-center-at-pga-frisco/reservations/${code}`
      : '/pga-coaching-center-at-pga-frisco/reservations'
  } else if (pathname.includes('lesson-pack')) {
    const coachBookingUrl = pathname.replace(
      /(\/coach\/[^/]+)\/.*/,
      '$1/schedule',
    )
    return coachBookingUrl
  } else if (pathname.includes('/things-to-do/events')) {
    const eventRegisterUrl = pathname.replace(/\/[^/]*$/, '/register')
    return eventRegisterUrl
  } else if (pathname.includes('private-lesson')) {
    const coachBookingUrl = pathname.replace(
      /(\/coach\/[^/]+)\/.*/,
      '$1/schedule',
    )
    return coachBookingUrl
  }
  window.rg4js &&
    window.rg4js('send', {
      error: new Error(`Invalid pathname, ${pathname}`),
      tags: ['product-purchase-confirmation-page'],
    })
  return null
}

const getPurchaseTypeByPathname = pathname => {
  if (pathname.includes('/practice-session')) {
    return 'practice-session'
  } else if (pathname.includes('/lesson-pack')) {
    return 'lesson-pack'
  } else if (pathname.includes('/things-to-do/events/')) {
    return 'group-event'
  } else if (pathname.includes('/private-lesson/')) {
    return 'private-lesson'
  }
  return null
}

export { getInitialPurchasePage, getPurchaseTypeByPathname }
